const TIME_FORMAT = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

const SHORT_DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
});

const isSameLocalDay = (a: Date, b: Date): boolean =>
  a.getDate() === b.getDate() &&
  a.getMonth() === b.getMonth() &&
  a.getFullYear() === b.getFullYear();

export function formatEventDate(timestamp: number): string {
  const date = new Date(timestamp);

  const time = TIME_FORMAT.format(date);

  if (isSameLocalDay(date, new Date())) {
    return `Today, ${time}`;
  }

  return `${SHORT_DATE_FORMAT.format(date)}, ${time}`;
}
